export default {


	breadcrumbBefore: ['Home', 'Member Center'], //  集運權限  和  官網展示 麵包屑

	// layout 



	locale: 'English',
	exit: 'Sign Out',
	hi: 'Hi,',

	loginOperations: ['Login', 'Register', 'Forgot Password'],
	signIn: ['SIGN IN', 'Forward'],

	navtop: [
		'HOME',
		// 'LOCAL SERVICE',
		// 'SHARING',
		'ECO',
		'FAQs',
		'NOTICE',
		'WAREHOUSE',
		'POINTs'
	],

	footer: {
		first: 'About Us',
		second: 'Disclaimer',
		third: 'Privacy Policy',
		fourth: 'Terms and Conditions',
		fifth: 'Manybo ©$ all rights reserved',
	},

	aside: { //侧边导航栏   children  子导航栏key
		first: {
			name: 'Member',
			children: ['My parcel', 'My Order']
		},
		second: {
			name: 'Sharing',
			children: ['Share now', 'My sharing', 'Comments']
		},
		third: {
			name: 'My profile',
			children: ['My profile', 'Warehouse', 'Address Book', 'Points', 'Sign out','Coupon']
		},
	},
	asideDescription: [{

			title: 'Business Cooperation',
			p: 'Provide the information of incoming parcel that is also used for Customs Clearence.',
			tips: {
				phone: 'Phone must be 8 to 11 digits',
				content: 'Description is not less than 2 characters',
				category: 'Category required'
			},
			form: [{
					placeholder: 'Please choose the type',
					label: 'Type',
					options: ['Business Cooperation', 'Offer Offer', 'Business Complaint']
				}, {
					label: 'Phone',
					placeholder: 'Fill in the phone number'
				}, {
					label: 'Description',
					placeholder: 'Fill in description.'
				},
				['Submit', 'Reset']
			]
		},
		{
			title: 'Contact Us',
			p: `<article class="strong">Customer service online time   </article><div ><div style="line-height:25px;">Monday to Saturday</div><div>09:30 - 12:30</div>
        </div><div>13:30 - 18:30</div> <span style="color:red;line-height:25px;" >red day off </span> <br /><article class="text-bold u-m-b-4 u-m-t-10">address</article>P.O.Box 87064 TO KWA WAN POST OFFICE`
		},
		{
			title: 'Facebook',
			p: []
		}
	],
	recommend: ['Recommendation', 'Price', 'Loading'], //   好物推荐这项 因为后加


	// 抽离 公用的
	commons: {
		OrderComment: ['Evaluation Order', 'Please give us feedback and let us improve our service. ',
			'Delivery service', 'Logistics limitation', 'Customer service quality', ' Submitting', ' Submit ','Photos(Optional)','Delivery service required', 'Logistics limitation required', 'Customer service quality required'
		],
		MoreInfo: { // components/pulic/MoreInfo
			last: 'No more',
			loading: 'Bobo is trying to load...',
			more: 'Click to load more',
			noneMessage: 'Bobo checked, there are no more data.',
		},
		FormButtons: {
			send: 'Submit',
			reset: 'Reset'
		},
		unit: { //单位  公用
			ge: 'Pieces',
			jian: 'Pieces',
			gong: 'Total'
		},
		input_placeholder: 'Please enter',
		select_placeholder: 'Please select',
		no_more: 'No data',
		successfully: 'Successful operation',
		unsuccessfully: 'Unsuccessful operation'

	},



	//  基础布局完毕
	jiyun: {
		breadcrumb: 'My parcel',
		expand: ['The goods have the following sub-waybill numbers', 'One-click claim'],
		form: {
			tips: 'Please send the logistics company and the waybill number to claim the shipment. When the goods arrive in the mainland warehouse, we will update the shipment information within 8 hours of office hours.',
			buttons: ['Submit', 'Reset'],

			eid: {
				label: 'Warehouse'
			},
			enum: {
				label: 'WaybillNo.'
			},
			repack: {
				label: 'Repack',
				desc: '(Need to charge service fee)'
			},
			items: {
				label: 'Declaration',
				tables: {
					title: 'Please declare the details of the goods truthfully',
					add: 'Add',
					props: {
						name: {
							label: 'Product name',
						},
						category: {
							label: 'Product category',
						},
						qty: {
							label: 'Quantity',
						},
						unit: {
							label: 'Unit price',
						},
						opera: {
							label: 'Operation',
							delete: 'Delete'
						}
					}
				}
			}
		},
		rules: {
			eid: `Please select the seller's shipping logistics company`,
			enum: 'Please enter the waybill number',
			items: 'Declaration information is incomplete'
		},

		form2: {
			label: 'do you know? Even if the goods are not in the warehouse, you can pre-select the goods to arrange the consignment. When the goods arrive, we will automatically deliver the goods to you (only for self-collection).',
			buttons: ['All', 'Unlisted', 'Already entered', {
				name: 'Forward',
				alert: 'Click the check box for select the parcel and then “Ship to me”. '
			}]
		}, //  title 是 hover 文字
		table: ['Courier', 'Tracking No', {
			column: 'Weight',
			title: ['Volume weight', 'size']
		}, 'Warehouse', 'Action'],
		operatingGroups: {
			search: {
				pop: 'Where’s my parcel'
			},
			re_declare: {
				pop: 'Re-declare'
			},
			delete: {
				pop: 'Delete',
				modal: {
					title: 'Bobo said',
					left: 'Are you sure you want to delete the item ',
					right: ' ?',
					confirm: 'confirm',
					cancel: 'cancel',
				}
			}
		},

		import: {
			key: 'Warehousing date',
			default: 'Unlisted'
		},
		custom: {
			key: 'custom declaration'
		},
		comment: {
			key: 'My notes',
			placeholder: 'Remarks are only visible to you',
			noShelfTips: 'Your parcel has been received. Since we have a huge volume of incoming parcels, we cannot register your parcel into our system on time. Please be patient and we will process the parcels as fast as we can. If your parcels have already been shown in the system, please consolidate your parcels as soon as possible in order to make room to the others. Thank you for co-operation.'
		},

		request: { // show_ship_limit_notice 方法中 confirm提示
			title: 'Notice of Domestic Banned Goods Update',
			content: `China Customs has notified that domestic collections will list the following items as prohibited items from now on, please pay attention. <br/> All the goods transshipped through our company will be 100% inspected by X-ray machines, please all customers to declare truthfully. <br/> If any prohibited items or false information are found, they will always be returned or marked as embargoed. The relevant arrangements will not be notified and no compensation will be given. <br/> Please note that the prohibited goods are defined by the customs, and the types of goods may increase or decrease, so it includes but is not limited to the following products: Promote banners, drones, sticks, black T-shirts, solid T-shirts, metal tubes, fluorescent sticks, laser pens, masks, helmets, gloves, masks, eye masks, steel balls, flashlights and more. <br/> If you have any questions about the purchase of goods, please contact customer service first. We apologize for the inconvenience.`,
			confirm: {
				confirm: 'confirm',
				cancel: 'cancel',
			}
		},
	},

	payment: {
		breadcrumb: 'Pay for order',
		descs: {
			order: 'Order',
			type: 'Type',
			weight: 'Weight',
			amount: 'Amount',
			receiver: 'Receiver',
			phone: 'Phone',
			address: 'Address'
		},
		section_title: "We support the following payment methods",
		waiting_for_code: 'Wait a moment, the payment code is being generated',
		click_to: 'Click here to jump to $1 payment',
		paied_text: 'Click to complete the payment'
	},

	step2: {
		breadcrumb: '選擇集運方式',


		uncheck: 'Please select a shipping method',
		notify: {
			title: 'Tips',
			message: 'Bobo has helped you select the last consolidation method, if there is no change, you can go directly to the next step'
		},
		type_list: [{
				id: '',
				title: 'All types'
			},
			{
				id: 1,
				title: "Pick-up point"
			},
			{
				id: 2,
				title: "Pick-up car"
			},
			{
				id: 3,
				title: "Locker"
			},
			{
				id: 4,
				title: "Delivery"
			},
			{
				id: 5,
				title: "Domestic"
			},
			// {
			// 	id: 6,
			// 	title: "International"
			// }
		],
		cate_list: ['All areas', 'Hong Kong', 'Kowloon District', 'New Territories'],
		buttons: ['Number of goods', 'Not put in', 'Chargeable Weight'],
		nextButton: 'next',
		card: ['first', 'Continued each'], //卡片
		tips: {
			warn: 'Because some of the goods you have selected have not arrived in the warehouse, you can only choose to send them to the self-collection point. The order amount is for reference only, subject to review after the goods arrive.',
			info: 'No options available under the current filter'
		},
		loading: "loading",



		search: {
			placeholder: 'Please enter the address keyword, such as To Kwa Wan',
			label: 'Search',
			tip: `Can't find the option you want? Try to enter a keyword search. `,
			settle_weight: 'Settlement weight'
		},
		auto_forward_tips: 'The length of the self-pickup order is 1.5 meters and the weight is 10Kg. Be careful not to exceed the limit for automatic consolidation orders, otherwise there will be a chance that normal delivery will not be possible. ',
		locker_tips: 'The upper limit of each locker order for centralized transportation is 3kg; Size not exceeding 35x30x45 cm',
		alternative_mode_tips: [
			'Please select an alternative pick-up point',
			'If your parcels cannot fulfil the locker size requirement, we will deliver the parcels to your second preference location.',
			'Reset'
		],
		cate_all: 'All areas',

		no_keyword: 'Please enter a keyword',
		no_applicable: 'Not applicable',

	},
	step3: {
		breadcrumb: 'Confirm order',
		pageHeaders: [{
				title: 'Delivery information',
				subTitle: 'Change receiver information',
				list: ['Receive', 'Address', 'Postcode', 'Click here to fill in the area code'],
				default: 'No address available, click here to add'
			},
			// if ul keys     else table keys
			{
				title: 'Parcels',
				if: {
					left: ['Waybill', 'Weight'],
					right: [{
							label: 'Product name',
							placeholder: 'English product name'
						},
						{
							label: 'Material',
							placeholder: 'English material'
						},
						{
							label: 'Value',
							placeholder: 'Internal value'
						},
						{
							label: 'Quantity',
							placeholder: 'Internal quantity'
						}
					]
				},
				else: {
					labels: ['Courier', 'Tracking No', 'Weight', 'Volume weight', 'Information'],
					widthHover: 'size'
				}
			},


			{
				title: 'Order details',
				items: ['Order', 'Type',
					'Qty', 'Weight', 'Alternative'
				]
			},


			{
				title: 'Order settlement',
				key: 'Use points',
				unit: 'One',
				labels: ['Basic freight', 'Points deduction', 'Final payment', 'Submit order',
					'Overdue fee', 'Pay'
				],
				warn: 'After the current order is sent out, an automatic consolidation and consolidation order will be generated. After all the goods arrive in the warehouse, the system will automatically review and issue it. The weight and freight of the order are subject to the system review.',
				paymentLabel: {
					cash: 'Cash on delivery',
					online: 'Pay online'
				}
			},


			{
				title: 'Precautions',
				timelines: [
					'It is strictly forbidden to carry prohibited goods including counterfeit goods and any infringing goods, etc. The offenders will be sent to the government for treatment, and the households concerned will be terminated immediately.',
					'It is necessary to truthfully declare the express delivery method and pay the shipping fee, otherwise it will not be shipped, and the company has the right to recover the underpaid shipping and administrative fees of $ 500. ',
					'The company is not responsible for any indirect losses or other non-subjective losses caused by delays or losses in the delivery of goods.',
					'Points can be used to exchange cash for a minimum of 50 points and a maximum of 200 points. Duobao.com reserves the final decision on the use of points and the exchangeable amount. '
				]
			}
		],
		tips: { // javascript 中的提示文字     key 对应的方法
			handleChange: 'The amount redeemed using points cannot be higher than the amount payable for this consolidation',
			score_placeholder: {
				before: 'Total',
				after: 'piece',
				after2: 'piece，Not currently available'
			},
		},
		scoreLabel: 'Bonus',
		contactDialog: {
			title: 'Hint',
			content: 'Is the area code missing in the receiving phone number?'
		}
	},
	odrder: {
		breadcrumb: 'Order',

		// 顶部按钮 
		buttons: ['All Order', 'Pending', 'Being processed', 'Available'],
		card: {
			unit: 'Piece',
			status: ['Picked up', 'Available', 'Being processed', 'Shipped','Arrived at HK'],
			steps: ['Order has been created, please click next to continue',
				'The order has not been completed, please confirm the order before delivery',
				'The order has not been paid, please confirm the payment before delivery',
				'There is a vague declaration for the current order goods, please re-declare it to avoid customs seizure',
				'Total'
			],
			buttons: ['Next', 'Confirm', 'Pay', 'Re-declare', 'Cancel',
				'Trace', 'Evaluation', 'Parcels', 'Detail', 'Payment pendding'
			],
			tables: ['time', 'location and tracking progress'],
			completed: 'To be completed'

		},
		tips: {
			delete: {
				title: 'Bobo said',
				left: 'Are you sure you want to delete the order of #',
				right: ' ?',
				confirm: 'Confirm',
				cancel: 'Cancel',
			},
			track: ['Goods have left [Domestic Logistics Center] and are being sent to [Hong Kong Logistics Center]',
				'The goods have arrived [Hong Kong Logistics Center], we will arrange delivery as soon as possible',
				'The dispatcher is delivering for you. Delivery inquiries can be found on LiveChats official website',
				'Your goods have been delivered successfully. Thank you for using our service ',
				'Your program failed to be delivered, the delivery driver will make another appointment'
			],
			trackTitle: 'Tracking order #'
		}
	},

	detail: {
		breadcrumb: 'Order details page',
		myComment: ['My evaluation', 'Delivery Services', 'Logistics Aging', 'Customer Service Quality',
			'Click here to rate orders'
		], // Added in


		pageHeaders: [{
			title: 'Receipt information',
			labels: ['Receive', 'Address', 'Postal Code']
		}, {
			title: 'Order details',
			column: ['Order', 'Type', 'Pickup Pwd', 'Qty', 'Weight',
				'Transaction No.', 'Use points', 'Amount', 'Date', 'Shipping date', 'Logistics No.'
			]
		}, {
			title: 'Parcels',
			column: ['Courier', 'Tracking No', 'Weight', 'Volume weight', 'Information']
		}],
		buttons: ['Next', 'Confirm order', 'Pay shipping',
			'Cancel', 'Print', 'Payment pendding'
		],
		hover: 'Size',
		invoice:['Manybo','16/F Kerry Cargo Centre, 55 Wing Kei Road, Kwai Chung','Receipt no.','Offical Receipt']
	},



	memberCenter: { //
		userDetail: {
			breadcrumb: 'Member',
			pageHeaders: [{
					title: 'Address',
					labels: ['Consignee', 'Phone', 'Postal Code', 'Address']
				},
				{
					title: 'My profile',
					subTitle: 'Edit Profile',
					labels: [
						'Email', 'Taobao Account', 'Nickname', 'Phone', 'Bonus','Member Code'
					]
				},
			],
			dialog: {
				title: 'Edit profile',
				formItems: [
					'Nickname', 'Taobao Account', 'Phone', 'Old Password', 'New Password', 'Confirm'
				],
				send: 'Submit'
			},

		},
		exchangeCode: {
			breadcrumb: 'exchange',

			headerBox: ['Each point redemption code can only be used once. ',
				'The final interpretation right belongs to Manybo.com. '
			],
			curPoints: 'Current points',

			secondItem: {
				label: 'Bonus Code',
				placeholder: 'bonus code'
			},
			scoreListTitle: 'Details',
			scoreListTips: 'only data after October 28, 2020 will be shown',
			table: {
				name: 'Project description',
				points: 'Points',
				date: 'date'
			}

		}
	},
	login: {
		breadcrumb: "Login",
		left: {
			title: 'Member Login',
			items: [{
					label: 'email',
					placeholder: 'login account'
				},
				{
					label: 'Password',
					placeholder: 'Login password'
				}
			],
			button: 'Sign In',
			validateUsername: 'The username cannot be less than 5 digits',
			validatePassword: 'Password cannot be less than 5 digits'
		},
		right: {
			title: 'Not a member yet',
			items: ['Just fill in the simple information', 'Register as a member to use the service'],
			button: 'Become a Member'
		}
	},

	404: {
		list: ['Copyright', 'manybo.com', 'Please check that the URL you entered is correct or return to the homepage',
			'Home page'
		],
		message: 'Bobo said that you cannot enter this page ...'
	},
	declare: {
		breadcrumb: 'Re-declaration',
		title: 'Re-declaration',
		headerBox: 'According to customs requirements, the name of the goods must be truthfully declared, otherwise it may be seized. ',
		button: 'Send',
		valid_tip: 'Incomplete declaration data'
	},
	declare_oversea: {
		// 上面一样就取 declare 的
		title: 'Please declare the details of the goods truthfully',
		add: 'Add',
		tables: {
			name: 'Product name',
			category: 'Product Type',
			qty: 'quantity',
			unit: 'Unit price',
			oper: 'Operation',
			del: 'delete'
		},
		submit: 're-declare'
	},


	components: {
		order: {
			// Address management
			manage: {
				tip: 'Please select the receiving warehouse and enter the weight of the goods to calculate the consolidation charge. ',
				keyword: 'Please enter the search keyword',
				add: 'Add address',
				back: 'Return to order',
				delTips: 'Are you sure you want to delete the current address? '
			},
			template_address: {
				title: 'Please fill in the return address',
				gap_tips: [
					'Please correctly fill in the domestic return address and telephone number',
					'This is a temporary address, Xiaobao will not store it in the address book'
				]
			},
			address_manage: {
				section: 'Address Book',
				gap_tips: [
					'Please fill in the correct delivery address',
					'If it is a new call, Xiaobao will request SMS verification to ensure that it can be delivered correctly.'
				],
			},

			phone_manage: {
				section: 'Phonebook',
				gap_tips: [
					'If it is a new call, Xiaobao will request SMS verification to ensure that the pickup code can be received',
				]
			},
			// address form
			form: {
				title: 'Receiver',

				name: 'name',
				phone: 'phone',
				verify_code: 'Verification code',
				addressPrefix: 'Region',
				address: 'address',
				is_default: 'Default',

				button: 'OK'
			},
			// table of addresses
			table: {

				disable_tips: 'This Adress does not support delivery',
				def: 'Default',
				phone: 'Name/Phone',
				address: 'Address',
				operate: 'Operation',
				del: 'Del',
				update: 'Edit'
			}

		},
		public: {
			manyboVerifyCode: {
				sendMsg: 'Send verification code',
				sendingMsg: 'Sending',
				sentMsg: 'Countdown'
			}
		}

	},

	home: {
		news: 'NEWS',
		contact_us: 'CONTACT US',
		online_cs: 'SERVICE ONLINE',
		business_hours: 'PICK-UP POINT BUSINESS HOURS',
		facebook: 'FACEBOOK FANPAGE',
		partner:"PARTNERS",


	},
	warehouse: {
		breadcrumb: 'Warehouse And Price',
	},
	hk: {
		breadcrumb: 'Shipping Rate Calculator',
		title: 'CALCULATORS',
		tips: [
			'Please input the weight of the goods and the mode of collection to calculate the collection charge.',
			'The volume is used to calculate the package with low density. The calculated weight will be compared with the actual weight, and the heavier one will be used to calculate the freight.',
			'The following quotation is based on the most flat method of transportation. The price is for reference.'
		],
		form: {
			warehouse: {
				label: 'Warehouse',
				placeholder: 'Please select a receiving warehouse'
			},
			weight: {
				label: 'Weight',
				placeholder: 'Please enter the weight'
			},
			repack: {
				label: 'Repack QTY',
				placeholder: 'Please enter the quantity that needs to be unpacked'
			},
			volume: {
				label: 'Volume',
				length: 'Please enter the length',
				wide: 'Please enter the width',
				height: 'Please enter the height',
			},

			button: 'Estimate now'
		},

		search: {
			placeholder: 'Please enter the address keyword ,Such as To Kwa Wan。',
			label: 'Search',
			tip: `Can't find the option you want? Try to enter a keyword to search。`,
			settle_weight: 'Settlement weight'
		},
		empty: `Can't find any content~`,
		no_keyword: 'Please enter key words',
		rules: {
			wh_id: 'Please select receiving warehouse',
			volume: 'please fill in the size',
			weight: 'Please enter the weight',
		},
	},


	faq: {
		breadcrumb: 'FAQ'
	},
	contact: {
		breadcrumb: 'Pickup Point',
		search: {
			placeholder: 'Please enter the address keyword ,Such as To Kwa Wan。',
			label: 'Search',
			tip: `Can't find the option you want? Try to enter a keyword to search。`,
			settle_weight: 'Settlement weight'
		},
		no_keyword: 'Please enter key words',
		no_more: 'No more data',
		type_list: [{
				id: '',
				title: 'All types'
			},
			{
				id: 1,
				title: "Pick-up point"
			},
			{
				id: 2,
				title: "Pick-up car"
			},
			{
				id: 3,
				title: "Locker"
			}
		],

	},
	activation: {
		breadcrumb: 'Account Activation',
		tips: [
			'Click here', 'Resend a Activation Email',
			'Email reminder',
			'Email has been successfully sent to your mailbox, please activate your account in time. '
		]
	},
	forget: {
		breadcrumb: 'Forgot Password',
		form: [{
			placeholder: 'Please enter your email address',
			label: 'Email',
			btn: 'Send Code',
			pop: 'Please enter the correct email format',
			tip: 'Please enter your email address  (valid for 5 minutes)'
		}, {
			placeholder: 'Please fill in the verification code',
			label: 'Verification',
			pop: 'Please enter a valid verification code (6 digits)',
			tip: 'Please enter a valid verification code'
		}, {
			placeholder: 'Please fill in the login password',
			label: 'Reset Password',
			pop: 'Password is 6-16 characters',
			tip: 'Please set your new password'
		}, {
			placeholder: 'Please fill in the confirmation password',
			label: 'Confirm Password',
			pop: 'Please keep the same password as above',
			tip: 'Please enter the password again'
		}],
		buttons: ['Send', 'Reset']
	},
	register: {
		breadcrumb: 'Member Registration',
		dialog: ['Terms of Carriage', 'Agree', 'Disagree'],
		finish: ['Welcome to register as a Duobao member. ',
			'Log into your email to activate your account and enjoy the premium services of Doble Container Lines ',
			'Click here to go directly to login',
			'Automatically jump to login page in seconds'
		],
		form: [{
				placeholder: 'Please fill in email',
				label: 'Email',
				pop: 'Please enter the correct email format',
				tip: 'Email will be used as a login account, please fill in correctly'
			}, {
				placeholder: 'Please fill in Taobao nickname',
				label: 'Taobao Account',
				pop: 'Taobao nickname (3-30) characters',
				tip: 'Please enter a Taobao nickname (not email)'
			}, {
				placeholder: 'Please fill in your phone',
				prefix: {
					placeholder: 'Region',
					pop: 'Please select an area code',
					options: [
						"China",
						"Hong Kong",
						"Macao",
						"Malaysia",
						"United States",
						"Singapore",
						"Indonesia",
						"Thailand",
						"Philippines",
						"Japan",
						"new Zealand",
						"Australia",
						"Canada"
					],
				},
				pop: 'Fill in common number (8-11) characters',
				tip: 'Choose area code and fill in common number'
			}, {
				placeholder: 'Please fill in a nickname',
				label: 'nickname',
				pop: 'nickname 4-20 characters',
				tip: 'Please fill in your nickname'
			}, {
				placeholder: 'Please fill in the login password',
				label: 'Login Password',
				pop: 'Password is 6-16 characters',
				tip: 'Please set your password'
			}, {
				placeholder: 'Please fill in the confirmation password',
				label: 'Confirm Password',
				pop: 'Please keep the same password as above',
				tip: 'Please enter the password again'
			},
			{
				title: 'Redeem (Optional)',
				tip: 'You can enter the points redemption code here, and you can get the corresponding points after successful registration',
				label: 'Points redemption code',
				placeholder: 'Please enter the points redemption code'
			},

			{
				checkBox: ['I have read and agree', 'Terms of Carriage Contract'],
				buttons: ['Send', 'Reset']
			}
		]
	},


	article: {
		_id: {
			publishTime: 'release time'
		},

		process: {
			breadcrumb: 'Consolidation process',
			steps: [{
					title: '1.Online Shopping',
					step: [
						'You can shop on different websites and use our domestic address as the delivery address.',
						'Address: No. 8 Beixiaolong Road, Yuanshan, Changping Town, Dongguan City, Guangdong Province',
						'To: your name',
						'Telephone: 18680488481',
						'Zip: 523583'
					]
				},
				{
					title: '2. Product Claim',
					step: 'Enter the courier company and order number sent by the seller to claim the goods.'
				},
				{
					title: '3.Consolidation Hong Kong',
					step: 'After the goods arrive, select the goods you want to consolidate, and follow the instructions to select the consolidation method, enter the address, phone and other information, and the payment (or cash on delivery) will be shipped to Hong Kong immediately'
				}
			]
		}
	},
	indication: {
		jiyun: {
			first: 'Click here to enter the consolidation system',
			formIntro: [
				"Click here to select the logistics company that the seller ships from (if not, select the other)",
				"Here enter the number of the delivery note shipped by the seller",
				"Specify the name of the goods exactly and we will use it for customs declaration",
				"Then click here to submit and claim it.",
				"Then select the goods that need to be consolidated, click here to place an order"
			],
			navIntro: [
				"Claim goods and list of goods here",
				"Here you can view all order information in three months",
				"Here, you can share the baby you bought with Amoy friends, and you will get points reward after being reviewed by Duobao (points can be used to deduct freight)",
				"You can see all the babies I shared here",
				"You can reply to the message of Amoy friends",
				"Here you can check the shipping address and modify your account information",
				"Here you can see the available points in your account, and you can also redeem the points redemption code",
				"If you are not using a personal computer, remember to click here to log out of the system after use"
			]
		}
	},


}
